
<template>
  <v-container id="alerts" fluid tag="section">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      color="#007bff"
      :height="45"
      :width="75"
      :is-full-page="false"
    ></loading>
    <v-row justify="center">
      <v-dialog v-model="isAdvFormOpen" max-width="600">
        <template>
          <v-card>
            <v-form
              ref="advForm"
              v-model="validateAdvForm"
              lazy-validation
            >
              <v-card-title class="mt-2 mb-4">
                <span v-if="!editAdvMode" class="headline">Add Advertiser</span>
                <span v-else class="headline">Edit Advertiser</span>
              </v-card-title>
        
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-text-field
                      v-model="advertiserName"
                      label="Advertiser Name*"
                      outlined
                      dense
                      required
                      :rules="advertiserNameRules"
                    >
                    </v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="companyName"
                      label="Company Name*"
                      outlined
                      dense
                      required
                      :rules="companyNameRules"
                    >
                    </v-text-field>
                  </v-row>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!validateAdvForm"
                  color="primary"
                  class="mr-4"
                  @click="addItem"
                  v-if="!editAdvMode"
                >
                  Save
                </v-btn>
                <v-btn
                  :disabled="!validateAdvForm"
                  color="primary"
                  class="mr-4"
                  @click="updateItem"
                  v-else
                >
                  Update
                </v-btn>
                <v-btn color="default" @click="isAdvFormOpen = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="isUploadDialogOpen" max-width="600">
  <v-card>
    <v-form ref="uploadForm" v-model="validateUploadForm" lazy-validation>
      <v-card-title class="mt-2 mb-4">
        <span class="headline">Upload CSV File</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-file-input
  v-model="csvFile"
  label="Select CSV File*"
  outlined
  dense
  accept=".csv"
  @change="onFileChange"
/>

          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
<v-btn
  :disabled="!csvFile"
  color="primary"
  class="mr-4"
  @click="uploadCsv"
>
  Upload
</v-btn>


        <v-btn color="default" @click="isUploadDialogOpen = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
<v-dialog v-model="isListCompanyDialogOpen" max-width="800">
  <v-card>
    <v-card-title class="mt-5">
      <span class="headline">Missing Companies List</span>
    </v-card-title>

    <v-card-text>
<v-data-table
  :headers="missingCompanyHeaders"
  :items="paginatedMissingCompanies"
  :items-per-page="missingPerPage"
  dense
  outlined
  class="elevation-1"
  hide-default-footer
>
  <template v-slot:item.index="{ index }">
    {{ index + 1 + (missingPage - 1) * missingPerPage }}
  </template>
</v-data-table>



<Pagination
  :key="missingPage"
  :isloading="isLoading"
  :startRecord="missingStartRecord"
  :currentPage="missingPage"
  :lastPage="missingTotalPages"
  :lastRecord="missingLastRecord"
  :totRecords="missingTotalRecords"
  :isCurrentPageClass="missingIsCurrentPageClass"
  :perpage="missingPerPage"
  :getLastPageClass="missingGetLastPageClass"
  :totPage="missingTotalPages"
  :getPages="missingPages"

  @handlePerPage="missingHandlePerPage"
  @paginate="missingPaginate"
  @last="missingLast"
  @getDataByPage="missingGetDataByPage"

  :showPerPage="true"
/>



    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="default" @click="isListCompanyDialogOpen = false">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>




    </v-row>
    <div class="text-right d-flex">
    <div class="text-right mt-5 mb-4">
      <v-btn
        small
        color="primary"
        dark
        class="mr-4"
        @click="openAdvForm(false)"
      >
        Add Advertiser
      </v-btn>
    </div>
      <div class="text-right mt-5 mb-4">
     <v-btn
  small
  color="primary"
  dark
  class="mr-4"
  @click="isUploadDialogOpen = true"
>
  Upload CSV
</v-btn>

    </div>
     <div class="text-right mt-5 mb-4">
<v-btn
  small
  color="primary"
  dark
  class="mr-4"
  @click="openMissingCompanies"
>
  List Missing Company
</v-btn>


    </div>
    </div>

    <v-row>
      <v-col cols="12">
        <v-card>
          <div>
            <v-data-table
              :headers="headers"
              item-key="product_id"
              :page.sync="page"
              :items="digital_data"
              :options.sync="options"
              :server-items-length="totRecords"
              :loading="isLoading"
              class="elevation-1"
              hide-default-footer
              @page-count="pageCount = $event"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  title="Edit Item"
                  @click="openAdvForm(true, item.id)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  title="Delete Item"
                  @click="deleteItem(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </div>
          <div class="text-center pt-4 pb-4">
            <Pagination
              :isloading="isLoading"
              :startRecord="startRecord"
              :currentPage="currentPage"
              :lastPage="lastPage"
              :lastRecord="lastRecord"
              :totRecords="totRecords"
              :isCurrentPageClass="isCurrentPageClass"
              :perpage="perpage"
              :getLastPageClass="getLastPageClass"
              :totPage="totPage"
              :getPages="getPages"
              @handlePerPage="handlePerPage"
              @paginate="paginate"
              @last="last"
              @getDataByPage="getDataByPage"
              :showPerPage="true"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import DashboardCoreView from "@/views/dashboard/CompanyAutocomplete";
import StatesCoreView from "@/views/dashboard/StateAutocomplete";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Pagination from "./component/Pagination.vue";
import moment from "moment";

export default {
  name: "ManageAdvertisersAndCompanies",

  components: {
    DashboardCoreView,
    StatesCoreView,
    Loading,
    Pagination,
  },

  data: () => ({
    //for loading//
    isLoading: true,
     isUploadDialogOpen: false,
      csvFile: null,
        missingPage: 1,
  missingPerPage: 10,
  missingTotalRecords: 0,
  missingTotalPages: 0,
       isListCompanyDialogOpen: false,
missingCompanies: [],
  missingCurrentPage: 1,
  missingLastPage: 1,
    missingCompanyHeaders: [
      { text: "#", value: "index" },
      { text: "Advertiser Name", value: "name" },
      { text: "Advertiser Domain", value: "reason" },
    ],
    // csvFileRules: [
    //   v => !!v || "CSV file is required",
    //   v => !v || v.name.endsWith('.csv') || "Only CSV files are allowed",
    // ],
    //form
    isAdvFormOpen: false,
    editAdvMode: false,
    editId: "",
    validateAdvForm: false,
    advertiserNameRules: [
      (v) => !!v.trim() || "Advertiser name is required",
    ],
    companyNameRules: [
      (v) => !!v.trim() || "Company name is required",
    ],
    advertiserName: "",
    companyName: "",
    //pagination code
    perpage: 10,
    totRecords: 0,
    page: 1,
    pageCount: 0,
    //////table data starts here
    options: {},
    digital_data: [],
    
    headers: [
      { text: "Date", value: "insert_date", width: "150px", sortable: false },
      { text: "Advertiser Name", value: "advertiser_name", sortable: false },
      { text: "Company Name", value: "competiscan_company", sortable: false },
      { text: "Action", value: "actions", width: "150px", sortable: false },
    ],
  }),

  computed: {
paginatedMissingCompanies() {
  return this.missingCompanies;  
},
missingStartRecord() {
  if (this.missingTotalRecords === 0) return 0;
  return (this.missingPage - 1) * this.missingPerPage + 1;
},
missingLastRecord() {
  return Math.min(this.missingPage * this.missingPerPage, this.missingTotalRecords);
},
missingGetLastPageClass() {
  return this.missingPage === this.missingTotalPages ? "" : "notactivespan";
},
missingIsCurrentPageClass() {
  return this.missingPage === 1 ? "" : "notactivespan";
},
missingPages() {
  return this.$utils.getPages(
    this.missingTotalPages,
    this.missingPage,
    this.missingTotalPages
  );
},




    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },
    totPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
    currentPage: function () {
      return this.page;
    },
    lastPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
  },
  watch: {
    "$store.state.Rawdata.current_active_module": function (o) {
      if (o) {
        this.getData();
      }
    },
    page() {
      this.getData();
    },
    perpage() {
      this.getData();
    },
  },
  mounted() {
    console.log('sdfdsf');
  },

  methods: {
fetchMissingCompanies() {
  this.isLoading = true;

  this.$fetch({ requiresAuth: true, operation: "view", vueScope: this })
    .get(this.$url("Missing_COMPANY_LIST"), {
      params: {
        page_number: this.missingPage,
        page_size: this.missingPerPage
      }
    })
    .then(res => {
      const payload = res.data.payload;

 this.missingCompanies = payload.data.map((item, i) => ({
  index: i + 1 + (this.missingPage - 1) * this.missingPerPage,
  name: item.advertiser_name,
  reason: item.advertiser_domain
}));
      this.missingTotalPages = payload.total_pages;
      this.missingTotalRecords = payload.total_records;

      this.isLoading = false;
    })
    .catch(err => {
      console.error(err);
      this.isLoading = false;
    });
},


missingGetDataByPage(page) {
  this.missingPage = page;
  this.fetchMissingCompanies();
},

missingPaginate(step) {
  let next = this.missingPage + step;
  if (next < 1) next = 1;
  if (next > this.missingTotalPages) next = this.missingTotalPages;
  this.missingPage = next;
  this.fetchMissingCompanies();
},

missingHandlePerPage(value) {
  this.missingPerPage = Number(value);  
  this.missingPage = 1;
  this.fetchMissingCompanies();
},


missingLast() {
  this.missingPage = this.missingTotalPages;
  this.fetchMissingCompanies();
},

missingFirst() {
  this.missingPage = 1;
  this.missingPages = this.$utils.getPages(
    this.missingTotalPages,
    1,
    this.missingTotalPages
  );

  this.fetchMissingCompanies();
},




    //pagination methods
    getDataByPage(value) {
      this.page = value;
    },
    openMissingCompanies() {
    this.isListCompanyDialogOpen = true;
     this.fetchMissingCompanies();
  },

onFileChange(file) {
    this.csvFile = file;  
  },
uploadCsv() {
  if (this.csvFile) {
    const view = this;
    view.isLoading = true;
    
    const formData = new FormData();
    formData.append('file', this.csvFile);

    let url = this.$url("UPLOAD_CSV");

    this.$fetch({ requiresAuth: true, operation: "add", vueScope: view })
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        view.isLoading = false;
        view.isUploadDialogOpen = false;
        view.csvFile = null;
        view.$swal.fire({
          icon: "success",
          title: "Success",
          text: response.data?.message || "CSV uploaded successfully!",
        });
        view.getData();
      })
      .catch((error) => {
        console.error(error);
        view.isLoading = false;
        view.$swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Failed to upload CSV!",
        });
      });
  }
},

    handlePerPage(value) {
      this.perpage = value;
    },
    paginate(n) {
      if(n==0){
        // First page
        this.page = 1
      }else{
        const nextPage = this.page + n;
        this.page = Math.min(Math.max(1, nextPage), this.pageCount)
      }
    },
    last() {
      this.page = this.lastPage;
    },
    /////
    getData() {
      this.isLoading = true;
      let digital_dashboard_url = this.$url("DIGITALDASHBOARD");

      this.$fetch({ requiresAuth: true, operation: "view", vueScope: this })
        .get(digital_dashboard_url,  { params: { page_number: this.page, page_size: this.perpage } })
        .then((response) => {
          this.isLoading = false;
          const data = response.data?.payload??{};
          this.digital_data = data.data;
          this.totRecords = data.count;
          this.pageCount = data.total_pages;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    },
    openAdvForm(editMode, id = 0) {
      this.isAdvFormOpen = true;
      if (editMode) {
        this.editAdvMode = true;
      } else {
        this.editAdvMode = false;
        this.advertiserName = "";
        this.companyName = "";
        this.$refs.advForm.resetValidation()
      }
      if (id != 0) {
        this.getItemDetails(id);
      }
    },
    addItem() {
      if (this.$refs.advForm.validate()) {
        const payload = JSON.stringify({ 
          "advertiser_name": this.advertiserName,
          "competiscan_company": this.companyName
        })
        
        let digital_dashboard_url = this.$url("DIGITALDASHBOARD");
        this.isLoading = true;
        this.$fetch({ requiresAuth: true, operation: "add", vueScope: this })
          .post(digital_dashboard_url, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            this.isLoading = false;
            this.isAdvFormOpen = false;
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: response.data.message,
            });
            this.getData();
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: error.response?.data?.message || "Something went wrong!",
            });
          });
      }
    },
    updateItem() {
      let view = this;
      if (view.$refs.advForm.validate()) {
        const payload = JSON.stringify({ 
          "id": this.editId,
          "advertiser_name": this.advertiserName,
          "competiscan_company": this.companyName,
        })
        
        
        let digital_dashboard_url = this.$url("DIGITALDASHBOARD");
        view.isLoading = true;
        this.$fetch({ requiresAuth: true, operation: "edit", vueScope: view })
          .put(digital_dashboard_url, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            view.isLoading = false;
            view.isAdvFormOpen = false;
            view.$swal.fire({
              icon: "success",
              title: "Success",
              text: response.data.message,
            });
            view.getData();
          })
          .catch((error) => {
            console.error(error);
            view.isLoading = false;
            view.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          });
      }
    },
    getItemDetails(id) {
      let view = this;
      let digital_dashboard_details_url = this.$url("DIGITALDASHBOARDDETAILS");
      view.isLoading = true;
     
      this.$fetch({ requiresAuth: true, operation: "view", vueScope: view })
        .get(digital_dashboard_details_url, { params: { id } })
        .then((response) => {
          view.isLoading = false;
          const data = response.data?.payload?.data;
          if(data){
            view.editId = data.id;
            view.advertiserName = data.advertiser_name;
            view.companyName = data.competiscan_company;
          }
        })
        .catch((error) => {
          console.error(error);
          view.isLoading = false;
          view.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    },
    deleteItem(id) {
      let view = this;
      let digital_dashboard_url = this.$url("DIGITALDASHBOARD");
      view.$swal
        .fire({
          title: "Are you sure ?",
          text: "This will delete this item",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it !",
          cancelButtonText: "No, cancel !",
          closeOnConfirm: false,
          closeOnCancel: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            view.isLoading = true;
            this.$fetch({
              requiresAuth: true,
              operation: "delete",
              vueScope: view,
            })
              .delete(digital_dashboard_url, {
                params: { id },
                headers: {
                  "Content-Type": "application/json",
                }})
              .then((response) => {
                view.isLoading = false;
                console.log(response.data?.message);
                view.$swal.fire({
                  icon: "success",
                  title: "Success",
                  text: response.data?.message || "Data deleted successfully",
                });
                view.getData();
              })
              .catch((error) => {
                console.error(error);
                view.isLoading = false;
                view.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Something went wrong!",
                });
              });
          } else if (result.isDenied) {
            view.$swal.fire("Cancelled", "File was not deleted!", "error");
          }
        });
    },
  },
};
</script>
